<template>
  <div class="invoices">
    <h3>发票管理</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      v-loading="loading"
      size="mini"
    >
      <el-form-item label="用户id">
        <el-input
          v-model.number="filter.userId"
          placeholder="用户id"
        ></el-input>
      </el-form-item>
      <el-form-item label="发票抬头">
        <el-input v-model="filter.enterprise" placeholder="发票抬头"></el-input>
      </el-form-item>
      <el-form-item label="发票状态">
        <el-select v-model="filter.status" placeholder="请选择发票状态">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(key, val) in map.invoice.status"
            :key="val"
            :label="key"
            :value="val"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号">
        <el-input
          v-model="filter.trackingNum"
          placeholder="快递单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-col :span="11">
          <el-date-picker
            v-model="filter.createTimeStart"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
            :picker-options="topupOptionsStart"
            style="margin-right: 10px"
          >
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker
            v-model="filter.createTimeEnd"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
            :picker-options="topupOptionsEnd"
            style="margin-left: 10px"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="fetch(1)"
          size="mini"
          >查询</el-button
        >
        <el-button type="primary" size="mini" @click="exportExcel"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column
        prop="invoiceId"
        label="ID"
        width="200"
      ></el-table-column>
      <el-table-column prop="enterprise" label="发票抬头"></el-table-column>
      <el-table-column
        prop="amount"
        width="120"
        label="开票金额/元"
      ></el-table-column>
      <el-table-column prop="wuYouAmount" label="用工无忧" />
      <el-table-column prop="aiSaiAmount" label="爱赛" />
      <el-table-column prop="dongJiAmount" label="东绩" />
      <el-table-column
        prop="createTime"
        label="申请时间"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="confirmTime"
        label="开票时间"
        width="150"
      ></el-table-column>
      <el-table-column prop="status" label="发票状态">
        <template slot-scope="scope">{{
          map.invoice.status[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column prop="prePayPending" label="发票详情">
        <template slot-scope="scope">
          <a :href="`/invoice/detail/${scope.row.invoiceId}`" target="_blank"
            >查看</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="trackingNumber"
        label="快递单号"
        sortable
        width="160"
      ></el-table-column>
      <el-table-column
        prop="rejectRemark"
        label="备注"
        width="160"
      ></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button-group size="mini">
            <el-button
              size="mini"
              type="primary"
              :disabled="scope.row.status !== 1"
              @click="toggleDialog('confirm', scope.row)"
              >确认</el-button
            >
            <el-button
              size="mini"
              type="primary"
              :disabled="scope.row.status !== 1"
              @click="toggleDialog('reject', scope.row)"
              >驳回</el-button
            >

            <span v-if="menuList.includes('发票编辑')">
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.status == 2"
                @click="changeDialog(scope.row)"
                >修改</el-button
              >
            </span>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="请填写驳回理由" :visible.sync="dialog.reject">
      <el-input
        type="textarea"
        placeholder="请填写驳回理由"
        :rows="5"
        v-model.trim="rejectRemark"
        maxlength="150"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="toggleDialog('reject')">取 消</el-button>
        <el-button type="primary" @click="reject()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="请填写发票开具结果" :visible.sync="dialog.confirm">
      <el-input
        type="textarea"
        placeholder="请填写快递单号或已开具电子发票"
        :rows="5"
        v-model.trim="trackingNum"
        maxlength="150"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="toggleDialog('confirm')">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { invoice, menu } = api;

import moment from "moment";

export default {
  name: "invoices",
  data() {
    return {
      menuList: [], // 权限列表
      map,
      loading: false,
      list: [],
      total: 0,
      pageNum: 1,
      limit: 20,
      filter: {
        enterprise: "",
        status: "",
        trackingNum: "",
        createTimeStart: "",
        createTimeEnd: "",
        userId: "",
      },
      topupOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.filter.createTimeEnd;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      topupOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.filter.createTimeStart;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      dialog: {
        reject: false,
        confirm: false,
      },
      curData: {},
      rejectRemark: "",
      trackingNum: "",
      invoiceId: "",
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {
    this.menuList = JSON.parse(localStorage.getItem("menuList")) || [];
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      this.loading = true;
      let {
        enterprise,
        status,
        trackingNum,
        createTimeStart,
        createTimeEnd,
        userId,
      } = this.filter;
      let obj = {
        enterprise,
        status,
        trackingNum,
        createTimeStart,
        createTimeEnd,
        userId: Number.isInteger(userId) ? userId : "",
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let res = await invoice.list(obj);
      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },

    async exportExcel() {
      this.loading = true;
      let {
        enterprise,
        status,
        trackingNum,
        createTimeStart,
        createTimeEnd,
        userId,
      } = this.filter;
      let obj = {
        enterprise,
        status,
        trackingNum,
        createTimeStart,
        createTimeEnd,
        userId: Number.isInteger(userId) ? userId : "",
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let resp = await invoice.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      console.log(link);
      link.download = decodeURIComponent("发票管理列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },

    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
      if (data) {
        this.curData = data;
        this.trackingNum = "";
        this.rejectRemark = "";
      } else {
        this.curData = {};
      }
    },
    async reject() {
      let obj = {
        invoiceId: this.curData.invoiceId
          ? this.curData.invoiceId
          : this.invoiceId,
        rejectRemark: this.rejectRemark,
      };
      if (!obj.rejectRemark) {
        this.$message.error("驳回原因不能为空");
        return false;
      }
      let {
        data: { code },
      } = await invoice.reject(obj);
      if (code == 200) {
        this.$message.success("操作成功");
        this.toggleDialog("reject");
        this.fetch();
      }
    },
    async confirm() {
      console.log(this.curData.invoiceId, "this.curData.invoiceId,");
      let obj = {
        // invoiceId: this.curData.invoiceId,
        invoiceId: this.curData.invoiceId
          ? this.curData.invoiceId
          : this.invoiceId,
        trackingNum: this.trackingNum,
      };
      if (!obj.trackingNum) {
        this.$message.error("快递单号不能为空");
        return false;
      }
      let {
        data: { code },
      } = await invoice.confirm(obj);
      if (code == 200) {
        this.$message.success("操作成功");
        this.toggleDialog("confirm");
        this.fetch();
      }
    },
    changeDialog(row) {
      this.trackingNum = row.trackingNumber;
      this.invoiceId = row.invoiceId;
      this.dialog.confirm = true;
    },
  },
  mounted() {
    this.fetch(1);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/invoice/invoices.vue